module.exports = __webpack_public_path__ + "img/use-of-funds.7010bc44.jpg";